import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import Radio, { IRadio } from './radio';
import RichText from '../../rich-text';

interface IRadioButton extends IRadio {
	ref: React.RefObject<HTMLInputElement>;
}

const RadioButton: React.FC<IRadioButton> = ({
	id,
	label,
	defaultValue,
	ref,
	name,
	checked,
	value,
	disabled,
	onChange,
	onFocus,
	onClick,
	className,
}) => {
	const innerRef = ref || useRef(null);
	const [isHover, setIsHover] = useState<boolean>(false);
	return (
		<div
			onMouseOver={() => setIsHover(true)}
			onMouseOut={() => setIsHover(false)}
			className={classNames(
				'flex rounded-full h-14 px-3 items-center shadow-leap',
				className,
				{ 'ring-2 ring-brand': checked },
				{ 'ring-2 ring-brand': isHover && !disabled }
			)}
			onClick={() => innerRef.current?.click()}>
			<Radio
				id={id}
				ref={innerRef}
				name={name}
				checked={checked}
				onClick={onClick}
				onChange={onChange}
				onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
					if (onFocus) {
						onFocus(event);
					}
				}}
				value={value}
				defaultValue={defaultValue}
				disabled={disabled}
				isHover={isHover}
			/>
			<label htmlFor={id} className="ml-3 text-font">
				<RichText html={label as string} />
			</label>
		</div>
	);
};

export default RadioButton;
